const SYNC_FLOW_MEDIA_STEPS = {
  PRODUCT_MEDIA: 'productMedia',
  VARIANT_MEDIA: 'variantMedia',
};

export default SYNC_FLOW_MEDIA_STEPS;
